export var WheelOptionsClasses;
(function (WheelOptionsClasses) {
    WheelOptionsClasses["NUMBERS"] = "SECTOR_1_YES";
    WheelOptionsClasses["CUP"] = "SECTOR_COLOR_WHITE";
    WheelOptionsClasses["BLACK"] = "SECTOR_COLOR_BLACK";
    WheelOptionsClasses["GREY"] = "SECTOR_COLOR_GREY";
    WheelOptionsClasses["RED"] = "SECTOR_COLOR_RED";
    WheelOptionsClasses["FROM_1_TO_6"] = "SECTOR_1_TO_6";
    WheelOptionsClasses["FROM_7_TO_12"] = "SECTOR_7_TO_12";
    WheelOptionsClasses["FROM_13_TO_18"] = "SECTOR_13_TO_18";
    WheelOptionsClasses["LESS_9_5"] = "SECTOR_LESS_9_5";
    WheelOptionsClasses["MORE_9_5"] = "SECTOR_MORE_9_5";
    WheelOptionsClasses["EVEN"] = "SECTOR_NUMBER_EVEN";
    WheelOptionsClasses["ODD"] = "SECTOR_NUMBER_ODD";
    WheelOptionsClasses["GREY_EVEN"] = "SECTOR_NUMBER_GREY_EVEN";
    WheelOptionsClasses["GREY_ODD"] = "SECTOR_NUMBER_GREY_ODD";
    WheelOptionsClasses["RED_EVEN"] = "SECTOR_NUMBER_RED_EVEN";
    WheelOptionsClasses["RED_ODD"] = "SECTOR_NUMBER_RED_ODD";
    WheelOptionsClasses["BLACK_EVEN"] = "SECTOR_NUMBER_BLACK_EVEN";
    WheelOptionsClasses["BLACK_ODD"] = "SECTOR_NUMBER_BLACK_ODD";
})(WheelOptionsClasses || (WheelOptionsClasses = {}));
